<script setup lang="ts">
interface Props {
  label: string
  value: string
  isHighlighted?: boolean
}
defineProps<Props>()
</script>

<template>
  <div class="text-center">
    <div
      :class="[
        'text-sm font-bold',
        isHighlighted ? 'text-primary-600' : 'text-gray-800'
      ]"
    >
      {{ label }}
    </div>
    <div
      :class="[
        'font-bold',
        isHighlighted ? 'text-lg text-primary-600' : 'text-sm text-gray-700'
      ]"
    >
      {{ value }}
    </div>
  </div>
</template>
